import script from "./AlocarTarefasparaequipe.vue?vue&type=script&setup=true&lang=js"
export * from "./AlocarTarefasparaequipe.vue?vue&type=script&setup=true&lang=js"

import "./AlocarTarefasparaequipe.vue?vue&type=style&index=0&id=51caa0a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51caa0a2"]])

export default __exports__